<div class="contenedor-editar-espacio" [ngSwitch]="opcionActual">
  <app-grupo-botones [seleccionado]="opcionActual" [botones]="opciones" (funcionEvent)="handleOpcion($event)">
  </app-grupo-botones>
  
  <mat-spinner *ngIf="!informacionForm"></mat-spinner>
  <ng-container *ngIf="informacionForm" >
    <form [formGroup]="informacionForm" (ngSubmit)="
        !informacionForm.invalid && editarInformacion(informacionForm.value)
      " *ngSwitchCase="'Información'" class="formulario-informacion">
      <span>Nombre</span>
      <input type="text" class="input-texto" placeholder="Nombre " formControlName="nombre" readonly/>
      <span>Descripción</span>
      <textarea class="input-texto" placeholder="Descripción" formControlName="descripcion"></textarea>
      <!-- <span>Imagen</span>
      <div class="input-imagen" *ngIf="!informacionForm.value.imagen">
        <img src="assets/espacios/nube-subir.svg" alt="Subir archivo" />
        <span> Arrastra y suelta tu imagen aquí ó</span>
        <label><input type="file" accept="image/*" formControlName="imagen" (input)="showPreviewInformacion($event)" />
          Subir imagen</label>
      </div> -->
      <div class="input-imagen-seleccionada" *ngIf="informacionForm.value.imagen"
        [style.backgroundImage]="'url(' + informacionImagen + ')'">
        <label (click)="this.informacionForm.patchValue({ imagen: null })">Remover imagen</label>
      </div>
      <span>Estado</span>
      <div class="botones-estado">
        <button [class.boton-primario]="estado === 1" (click)="cambiarEstado(1)">Activo</button>
        <button [class.boton-primario]="estado === 0" (click)="cambiarEstado(0)">Inactivo</button>
      </div>
      <ng-component></ng-component>
      <app-botones-cambios (onGuardar)="guardarInformacionBasica()" (onCancelar)="cancelarCambiosInformacionBasica()" [mostrar]="hayCambiosInformacionBasica"></app-botones-cambios>
    </form>
  </ng-container>

  <!-- Horarios -->
  <mat-spinner *ngIf="cargandoHorarios"></mat-spinner>

  <ng-container *ngIf="!cargandoHorarios">
    <div
      *ngSwitchCase="'Horarios'" class="formulario-horarios">
  
      <!-- Horarios ya existentes -->
      <app-horario *ngFor="let key of llavesHorariosForms" [formGroup]="horariosForms.get(key)"></app-horario>
      
      <!-- Nuevos Horarios -->
      <app-horario *ngFor="let formNuevoHorario of nuevosHorariosForms" [formGroup]="formNuevoHorario"></app-horario>
  
      <button class="boton-primario boton-añadir-horario" (click)="agregarHorario()">
        Añadir horarios
      </button>
      <app-botones-cambios (onGuardar)="guardarCambios()" (onCancelar)="cancelarCambios()" [mostrar]="hayCambios"></app-botones-cambios>
    </div>
  </ng-container>

  <!-- Imagenes -->
  <mat-spinner *ngIf="cargandoImagenes"></mat-spinner>

  <ng-container *ngIf="!cargandoImagenes">
    <div *ngSwitchCase="'Imagenes'" class="formulario-imagenes">
      <span>Imagenes App</span>
      <div [espacioLibre]="5 - imagenesVisibles.length" (fileDropped)="onFileDropped($event)" class="container-imagen-principal" [ngStyle]="
          imagenesVisibles.length > 0
            ? { 'background-image': 'url(' + imagenesVisibles[0].url_imagen.replaceAll('container1', 'container2') + ')' }
            : {}
        " appDnd>
        <mat-icon aria-hidden="false" aria-label="Example home icon" style="color: white;" *ngIf="imagenesVisibles[0]"
          (click)="eliminarPreviewImagenes(imagenesVisibles[0].posicion)">cancel</mat-icon>
        <img *ngIf="imagenesVisibles.length === 0" src="assets/espacios/nube-subir.svg" alt="Subir archivo" />
        <span *ngIf="imagenesVisibles.length === 0">
          Arrastra y suelta tu imagen aquí ó</span>
        <label *ngIf="imagenesVisibles.length < 5" [ngStyle]="{'margin-top': imagenesVisibles.length > 0 ? '12em' : 0}"><input type="file" accept="image/*" (input)="showPreviewImagenes($event);"/>
          {{imagenesVisibles.lenght === 0?"Subir imagen":"Subir más imagenes"}}</label>
      </div>
      <div *ngFor="let item of numSequence(4); let i = index;" [class]="'container-imagen-' + (i+1)" [ngStyle]="
          imagenesVisibles.length > (i+1)
            ? { 'background-image': 'url(' + imagenesVisibles[i+1].url_imagen.replaceAll('container1', 'container2') + ')' }
            : {}
        ">
        <mat-icon aria-hidden="false" aria-label="Example home icon" style="color: white" *ngIf="imagenesVisibles.length > (i+1)"
          (click)="eliminarPreviewImagenes(imagenesVisibles[i+1].posicion)">cancel</mat-icon>
      </div>
  
      <app-botones-cambios (onGuardar)="guardarImagenes()" (onCancelar)="cancelarCambiosImagenes()" [mostrar]="hayCambiosImagenes"></app-botones-cambios>
    </div>
  </ng-container>
</div>
